import { useState } from "react";

export const useSubmitState = () => {
  const [submitState, setSubmitState] = useState<
    "not-submitted" | "pending-response" | "success" | "error"
  >("not-submitted");
  return [submitState, setSubmitState] as const; // idk why but adding as const allows for correct state suggestion with vs code
};
